import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import Swal from "sweetalert2";
import ServiceCategoryNavbar from "./ServiceCategoryNavbar";

const ServiceCity = () => {
  const [categories, setCategories] = useState([]);
  const [whatWeDoId, setWhatWeDoId] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [subcategoryId, setSubcategoryId] = useState("");
  const [stateId, setStateId] = useState("");
  const [cities, setCities] = useState([]);
  const [cityInput, setCityInput] = useState([]);
  const [states, setStates] = useState([]);

  useEffect(() => {
    axios.get(`${baseurl}getAllServiceCategories`)
      .then((res) => {
        setCategories(res.data.data || []);
      })
      .catch((err) => {
        console.error("Fetch categories error:", err);
      });
  }, []);

  useEffect(() => {
    // Fetch states when subcategory changes
    if (subcategoryId) {
      const stateList = categories.filter(cat => cat.parent_id === parseInt(subcategoryId));
      setStates(stateList);
      setStateId(""); // Reset selection
    } else {
      setStates([]);
    }
  }, [subcategoryId, categories]);

  const generateSlug = (text) => {
    return text.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9\-]/g, "");
  };

  const handleAddCity = () => {
    const trimmedCity = cityInput.trim();
    if (!trimmedCity) return;
    if (cities.includes(trimmedCity)) {
      Swal.fire("Duplicate", "City already added", "warning");
      return;
    }
    setCities([...cities, trimmedCity]);
    setCityInput("");
  };

  const handleRemoveCity = (index) => {
    const newCities = [...cities];
    newCities.splice(index, 1);
    setCities(newCities);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stateId) {
      Swal.fire("Error", "Please select a state", "error");
      return;
    }
    if (cities.length === 0) {
      Swal.fire("Error", "Please add at least one city", "error");
      return;
    }

    try {
      for (const city of cities) {
        const payload = {
          service_title: city,
          has_service: true,
          slug: generateSlug(city),
          parent_id: stateId
        };
        await axios.post(`${baseurl}addServiceCategory`, payload);
      }
      Swal.fire("Success", "Cities added successfully!", "success").then(() => window.location.reload());
    } catch (err) {
      console.error("Submit error:", err);
      Swal.fire("Error", "Failed to add one or more cities", "error");
    }
  };

  const whatWeDoList = categories.filter(cat => cat.parent_id === null);
  const categoryList = categories.filter(cat => cat.parent_id === parseInt(whatWeDoId));
  const subcategoryList = categories.filter(cat => cat.parent_id === parseInt(categoryId));

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid text-start">
          <ServiceCategoryNavbar />

          <div className="crd1">
            <h4 className="mb-3">Add Cities under State</h4>
            <div className="row">
              <div className="col-md-6">
                <form onSubmit={handleSubmit} className="row g-3 text-start">

                  {/* What We Do Dropdown */}
                  <div className="col-md-12">
                    <label>What We Do</label>
                    <select
                      className="form-select"
                      required
                      value={whatWeDoId}
                      onChange={(e) => {
                        setWhatWeDoId(e.target.value);
                        setCategoryId("");
                        setSubcategoryId("");
                        setStateId("");
                      }}
                    >
                      <option value="">-- Select --</option>
                      {whatWeDoList.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.service_title}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Category Dropdown */}
                  <div className="col-md-12">
                    <label>Category</label>
                    <select
                      className="form-select"
                      required
                      value={categoryId}
                      onChange={(e) => {
                        setCategoryId(e.target.value);
                        setSubcategoryId("");
                        setStateId("");
                      }}
                      disabled={!whatWeDoId}
                    >
                      <option value="">-- Select --</option>
                      {categoryList.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.service_title}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Subcategory Dropdown */}
                  <div className="col-md-12">
                    <label>Subcategory</label>
                    <select
                      className="form-select"
                      required
                      value={subcategoryId}
                      onChange={(e) => {
                        setSubcategoryId(e.target.value);
                        setStateId("");
                      }}
                      disabled={!categoryId}
                    >
                      <option value="">-- Select --</option>
                      {subcategoryList.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.service_title}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* State Dropdown (under subcategory) */}
                  <div className="col-md-12">
                    <label>State</label>
                    <select
                      className="form-select"
                      required
                      value={stateId}
                      onChange={(e) => setStateId(e.target.value)}
                      disabled={!subcategoryId}
                    >
                      <option value="">-- Select --</option>
                      {states.map((st) => (
                        <option key={st.id} value={st.id}>
                          {st.service_title}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* City Input & Add Button */}
                  <div className="col-md-9">
                    <label>City</label>
                    <input
                      type="text"
                      className="form-control"
                      value={cityInput}
                      onChange={(e) => setCityInput(e.target.value)}
                      placeholder="Enter city name"
                      disabled={!stateId}
                    />
                  </div>
                  <div className="col-md-3 d-flex align-items-end">
                    <button type="button" className="btn btn-secondary w-100" onClick={handleAddCity} disabled={!stateId}>
                      Add City
                    </button>
                  </div>

                  {/* City List */}
                  {cities.length > 0 && (
                    <div className="col-md-12">
                      <label>Cities to be added:</label>
                      <ul className="list-group">
                        {cities.map((ct, idx) => (
                          <li className="list-group-item d-flex justify-content-between align-items-center" key={idx}>
                            {ct}
                            <button type="button" className="btn btn-sm btn-danger" onClick={() => handleRemoveCity(idx)}>
                              Remove
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  <div className="col-12 text-end">
                    <button type="submit" className="btn btn-primary">Add Cities</button>
                  </div>

                </form>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ServiceCity;
